export interface IImageUploadRequest {
  imageType: IUploadType;
  images: File[];
  establishmentId: string;
}

export interface IImageUploadResponse {
  type?: IUploadType;
  url: string;
  publishedUrl?: string;
  status?: UploadState;
  error?: string;
  metadata?: IMetadata;
  name?: string;
  id?: number;
}

export interface IMetadata {
  name: string;
  sourceUrl: string;
  mediaFormat: string;
  locationAssociation: { category: string };
  googleUrl: string;
  thumbnailUrl: string;
  createTime: Date;
  dimensions: { widthPixels: number; heightPixels: number };
  insights: { viewCount: number };
}

export enum IUploadType {
  COVER = 'cover',
  LOGO = 'logo',
  IMAGE = 'image',
}

export enum UploadState {
  UPLOADING = 'UPLOADING',
  PUBLISHING = 'PUBLISHING',
  FAILED = 'FAILED',
  UPLOADED = 'UPLOADED',
  PUBLISHED = 'PUBLISHED',
}

export enum UploadRequestState {
  UPLOADING = 'UPLOADING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface IUploadedFile {
  file?: File;
  image?: IImage;
  error?: IUploadError;
}

export interface IImage {
  name?: string;
  url: string;
}

export enum AspectRatio {
  HORIZONTAL = 'HORIZONTAL',
  VERTIFICAL = 'VERTICAL',
}

export interface IUploadError {
  fileName: string;
  errorMessage: string;
}

export interface IImageDeleteRequest {
  files: IImageDeleteId[];
  establishmentId?: string;
}

export interface IImageDeleteId {
  mediaId?: string;
  url?: string;
}

export enum ImageActions {
  DELETE = 'DELETE',
  SAVE = 'SAVE',
}

export interface IFileViewerResult {
  image: File;
  action: ImageActions;
}
